export enum EDemandBlockTypes {
  DEMAND = 'demand',
  CHECK_CLEAN = 'clean_check',
}
